import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { unitByIdQueryOptions } from '@/service/vpc/queryOptions';

export const Route = createFileRoute('/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/maintenance')({
  component: MaintenanceLayout,
  errorComponent: ErrorBoundary,
  loader: async (opts) => {
    const { endCustomerUnitId } = opts.params;

    if (!endCustomerUnitId) {
      return;
    }

    return opts.context.queryClient.ensureQueryData(unitByIdQueryOptions({ endCustomerUnitId }));
  },
});

function MaintenanceLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}
